import { Fragment } from "react";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { CmeCreditRow } from "./CmeCreditRow";
import type { CmeCreditRowData } from "./types";

type Props = {
	caption: string;
	credits: CmeCreditRowData[];
};

export const CmeCreditTable = ({ caption, credits }: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			borderWidth={1}
			borderColor={theme.colors.outlineVariant}
			borderRadius={theme.roundness * 3}
			backgroundColor={theme.colors.surface}
			overflow="hidden"
		>
			<Box
				paddingHorizontal={16}
				paddingVertical={8}
				backgroundColor={theme.colors.surfaceVariant}
			>
				<Text
					variant="labelMedium"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					{caption}
				</Text>
			</Box>
			<Box height={1} backgroundColor={theme.colors.outlineVariant} />
			{credits.map((credit, index) => (
				<Fragment key={credit.id}>
					{index > 0 ? (
						<Box paddingHorizontal={16}>
							<Box height={1} backgroundColor={theme.colors.outlineVariant} />
						</Box>
					) : null}
					<CmeCreditRow credit={credit} />
				</Fragment>
			))}
		</Box>
	);
};
